import React from "react";
import { ListItem } from "@material-ui/core";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { useSelector } from "react-redux";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Slider from "@material-ui/core/Slider";
import { withStyles } from "@material-ui/styles";
import Button from "@material-ui/core/Button";
import { isEqual } from "../helper";

const CustomSlider = withStyles({
  valueLabel: {
    top: -22,
    left: -11,
    fontSize: 15,
    "& *": {
      background: "transparent",
      color: "#000",
    },
  },
  thumb: {
    height: 14,
    width: 14,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  markLabel: {
    fontWeight: "bold",
    fontSize: 15,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
})(Slider);

const PriceFilter = ({ priceRangeToApply, setPriceRangeToApply }) => {
  //REDUX

  const themeColor = useSelector((state) => state.store.store.settings?.dark);
  const language = useSelector((state) => state.store.language);
  const minPrice = useSelector(
    (state) => state.productFilter?.allProductPriceRange?.[0]
  );
  const maxPrice = useSelector(
    (state) => state.productFilter?.allProductPriceRange?.[1]
  );

  //COMPONENT STATE
  const [open, setOpen] = React.useState(false);
  const value = priceRangeToApply;

  //COMPONENT FUNCTIONS
  const handleClick = () => {
    setOpen(!open);
  };

  const handleChangeRange = (event, newValue) => {
    setPriceRangeToApply(newValue);
  };

  const checkIfPriceRangeIsApplied = () => {
    return !isEqual(priceRangeToApply, [minPrice, maxPrice]);
  };

  const handleDisableApplyButton = () => {
    return (
      isEqual(value, priceRangeToApply) || isEqual(value, [minPrice, maxPrice])
    );
  };
  const valuetext = (value) => String(value);

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        style={{
          paddingLeft: language === "arabic" ? "" : 0,
          paddingRight: language === "arabic" ? 0 : "",
          marginTop: 15,
          direction: language === "arabic" ? "rtl" : "ltr",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              height: "26px",
              width: "6px",
              backgroundColor: checkIfPriceRangeIsApplied()
                ? themeColor
                : "transparent",
            }}
          ></div>
          <span
            style={{
              flex: 1,
              marginLeft: language === "arabic" ? 0 : 16,
              marginRight: language === "arabic" ? 16 : 0,
              fontWeight: "bold",
              fontSize: "15px",
              textAlign: language === "arabic" ? "right" : "left",
            }}
          >
            {language === "arabic" ? "السعر" : "Price"}
          </span>
          {checkIfPriceRangeIsApplied() && (
            <FiberManualRecordIcon
              style={{
                fontSize: 14,
                color: themeColor,
                marginRight: language === "arabic" ? 0 : 10,
                marginLeft: language === "arabic" ? 10 : 0,
              }}
            />
          )}
        </div>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <ListItem>
          <div
            style={{
              width: "100%",
              padding: "0 16px 0 16px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <CustomSlider
              value={value}
              marks={[
                {
                  value: minPrice,
                  label: `${minPrice}`,
                },
                {
                  value: maxPrice,
                  label: `${maxPrice}`,
                },
              ]}
              min={minPrice}
              max={maxPrice}
              defaultValue={[minPrice, maxPrice]}
              onChange={handleChangeRange}
              valueLabelDisplay={
                isEqual(value, [minPrice, maxPrice]) ? "off" : "on"
              }
              getAriaLabel={index => language === "arabic" ? (index === 0 ? "الحد الأدنى للسعر" : "الحد الأعلى للسعر") : (index === 0 ? "Minimum price" : "Maximum price")}
              getAriaValueText={valuetext}
            />
          </div>
        </ListItem>
      </Collapse>
    </>
  );
};

export default PriceFilter;
